var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgaeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12937",
    "data-name": "Path 12937",
    d: "M16,11.667a4.925,4.925,0,0,1-1.4,3.542,4.537,4.537,0,0,1-3.4,1.458,4.537,4.537,0,0,1-3.4-1.458,4.925,4.925,0,0,1-1.4-3.542A4.925,4.925,0,0,1,7.8,8.125a4.537,4.537,0,0,1,3.4-1.458,4.537,4.537,0,0,1,3.4,1.458A4.925,4.925,0,0,1,16,11.667Zm25.6,10V33.333H6.4v-5L14.4,20l4,4.167L31.2,10.833ZM44,3.333H4a.754.754,0,0,0-.562.247.818.818,0,0,0-.237.586V35.833a.818.818,0,0,0,.237.586A.754.754,0,0,0,4,36.667H44a.754.754,0,0,0,.563-.247.818.818,0,0,0,.237-.586V4.167a.818.818,0,0,0-.237-.586A.754.754,0,0,0,44,3.333Zm4,.833V35.833a4.1,4.1,0,0,1-1.175,2.943A3.776,3.776,0,0,1,44,40H4a3.776,3.776,0,0,1-2.825-1.224A4.1,4.1,0,0,1,0,35.833V4.167A4.1,4.1,0,0,1,1.175,1.224,3.776,3.776,0,0,1,4,0H44a3.776,3.776,0,0,1,2.825,1.224A4.1,4.1,0,0,1,48,4.167Z",
    fill: "#c2c2c2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgaeAlt);
export default __webpack_public_path__ + "static/media/imgaeAlt.3522cd16ca528a0c301ba2cffd0e5477.svg";
export { ForwardRef as ReactComponent };